import { render, staticRenderFns } from "./diploma-snippet.vue?vue&type=template&id=85fd7122&"
import script from "./diploma-snippet.vue?vue&type=script&lang=js&"
export * from "./diploma-snippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/QI.Recrutement.FE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCardText})
